/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';
window.Vue = Vue;
require('./bootstrap');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
// import {DraggableTree} from 'vue-draggable-nested-tree'
Vue.component('course-creator', require('./components/CourseCreator.vue').default);
Vue.component('quiz-creator', require('./components/QuizCreator.vue').default);
Vue.component('course-quiz-creator', require('./components/CourseQuizCreator.vue').default);
Vue.component('course', require('./components/Course.vue').default);
Vue.component('course-quiz-part', require('./components/CourseParts/Quiz.vue').default);
Vue.component('add-category-modal', require('./components/CourseParts/AddCategoryModal.vue').default);
Vue.component('responses-form', require('./components/ResponsesForm.vue').default);
Vue.component('inline-editor', require('./components/CourseParts/InlineEditor.vue').default);
Vue.component('course-blocks', require('./components/CourseParts/CourseBlocks.vue').default);
Vue.component('course-students', require('./components/CourseParts/CourseStudents.vue').default);
Vue.component('export-button-menu', require('./components/ImportExport/ExportButtonMenu.vue').default);
Vue.component('navbar', require('./components/NavBar.vue').default);
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('coauthors', require('./components/CourseParts/Coauthors.vue').default);
Vue.component('intl-phone-input', require('./components/FormComponents/IntlPhoneInput.vue').default);
Vue.component('student-group-editor', require('./components/StudentGroupEditor.vue').default);
Vue.component('training-editor', require('./components/TrainingEditor.vue').default);
Vue.component('essay-admin', require('./components/CourseParts/EssayAdmin.vue').default);
Vue.component('email-template-editor', require('./components/EmailTemplateEditor.vue').default);
Vue.component('password-input', require('./components/FormComponents/PasswordInput.vue').default);
Vue.component('student-calendar', require('./components/StudentCalendar.vue').default);
Vue.component('colour-picker-input', require('./components/FormComponents/ColorPickerInput.vue').default);
Vue.component('certificate', require('./components/Certificate.vue').default);
Vue.component('course-importer', require('./components/ImportExport/CourseImporter.vue').default);
Vue.component('student-course-details-viewer', require('./components/StudentCourseDetailsViewer.vue').default);
Vue.component('email-notifications-modal', require('./components/EmailNotificationsModal.vue').default);
Vue.component('ck-editor-box', require('./components/CKEditorBox.vue').default);
Vue.component('student-quiz-viewer', require('./components/StudentQuizViewer.vue').default);
Vue.component('dashboard', require('./components/Dashboard.vue').default);
Vue.component('dashboard-quiz-item', require('./components/DashboardQuizItem.vue').default);
Vue.component('progress-ring', require('./components/CourseParts/ProgressRing.vue').default);
Vue.component('dashboard-news-explorer', require('./components/DashboardNewsExplorer.vue').default);
Vue.component('help-text', require('./components/HelpText.vue').default);
Vue.component('null-safe-ck-editor', require('./components/NullSafeCkEditor.vue').default);
Vue.component('select-language', require('./components/SelectLanguage').default);
Vue.component('navbar-cart', require('./components/NavbarCart').default);

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import moment  from 'moment';

import CKEditor from '@ckeditor/ckeditor5-vue2';
Vue.use( CKEditor );

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import 'vue-croppa/dist/vue-croppa.css'
import Croppa from 'vue-croppa'
Vue.use(Croppa)

import Embed from 'v-video-embed'
Vue.use(Embed);

// ES6 Modules or TypeScript
import Swal from 'sweetalert2'

// CommonJS
window.swal = Swal;

Vue.mixin({
    methods: {
        route: route
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


Vue.filter('monthDateFormat', function (date) {
    if (!date) return ''
    return moment(date).format('MMMM DD YYYY');
});

Vue.filter('decodeEntities', function (value) {
    if (!value) return '';
    value = value.toString();
    const parsed = new DOMParser().parseFromString(value, "text/html");
    return parsed.documentElement.textContent;
});

Vue.filter('fileNameFromUrl', function (url) {
    var matches = url.match(/\/([^\/?#]+)[^\/]*$/);
    if (matches.length > 1) {
        return matches[1];
    }
    return null;
});

Vue.component('html-textarea',{
    template:'<div style="height: auto" contenteditable="true" @input="updateHTML" ref="editor"></div>',
    props:['value','scrollIntoView'],
    mounted: function () {
        this.$el.innerHTML = this.value;
        if(this.scrollIntoView) {
            if (!this.isScrolledIntoView(this.$refs.editor)) this.$refs.editor.scrollIntoView();
        }
    },
    methods: {
        updateHTML: function(e) {
            this.$emit('input', e.target.innerHTML);
        },
        isScrolledIntoView(elem)
        {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();

            var elemTop = $(elem).offset().top;
            var elemBottom = elemTop + $(elem).height();

            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }
    }
});

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        window.event = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', window.event)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', window.event)
    },
    stopProp(event) { event.stopPropagation() }
});

Vue.prototype.trans = (key) => {
    return _.get(window.trans, key, key);
};

Vue.directive('scroll', {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    }
    window.addEventListener('scroll', f);
  }
});

const app = new Vue({
    el: '#app',
});

require('./main.js');
